module.exports = {
  messages: {
    NETWORK_DIRECT_CONNECTIONS_HIRING_HIGHLIGHTS_CTA: 'View details',
    NETWORK_HIRING_HIGHLIGHTS_LOCATION: 'Cities',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_CTA: 'View profile',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_CTA_2: 'Register and connect',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_HEADLINE:
      'Looking for remote or hybrid jobs?',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_CONSTRUCTION: 'Construction',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_CONSULTING:
      'Consulting, IT and software development',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_DESCRIPTION: 'Hiring for',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_INSURANCE: 'Insurance',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_INTERNET_IT:
      'Internet and IT',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_IT_SECURITY: 'IT security',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_MECHANICAL_ENGINEERING:
      'Industry and mechanical engineering',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_ONLINE_MEDIA:
      'Internet and online media',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_SOFTWARE: 'Software',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_INDUSTRY_TELECOMMUNICATION:
      'Telecommunications',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_LINK: 'Show all',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_SUBLINE:
      'Get in touch with people offering remote, hybrid and flexible options:',
    NETWORK_LOGGED_OUT_DIRECT_CONNECTIONS_TAG: 'Hiring',
    NETWORK_LOGGED_OUT_DISCOVER_CTA: 'Start now',
    NETWORK_LOGGED_OUT_DISCOVER_HEADLINE:
      'Connect with people who can help with your job search',
    NETWORK_LOGGED_OUT_GET_DISCOVERED_CTA: 'Register now',
    NETWORK_LOGGED_OUT_GET_DISCOVERED_HEADLINE:
      'Join XING now and get found by hiring pros looking for talent like you.',
    NETWORK_LOGGED_OUT_HIRING_CTA: 'Add hiring details',
    NETWORK_LOGGED_OUT_HIRING_HEADLINE: 'Are you hiring?',
    NETWORK_LOGGED_OUT_HIRING_SUBLINE:
      'Spread the word and find the right people for your vacancies.',
    NETWORK_LOGGED_OUT_TOP_RECRUITERS_HEADLINE: 'Hiring pros on XING',
    NETWORK_LOGGED_OUT_TOP_RECRUITERS_SUBLINE:
      'Professionals hiring for top companies',
  },
};
